import { match } from '@/utils/pattern-match-util'
import type { UserDataType } from '@/features/iam/users/UserData'

/**
 * Gets the display name of a user type.
 *
 * @param userDataType
 */
export function getUserDataTypeDisplayName(userDataType: UserDataType) {
  return match(userDataType, {
    User: () => 'Client',
    Pro: () => 'Pro',
    Admin: () => 'Admin',
    CallAgent: () => 'Call Agent',
  })
}
